import { Route, useParams, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ProtectedRoute } from 'ProtectedRoute';
import { DeferralLinkComponent } from './components/DeferralLinkComponent';

export const DEFERRAL_LINK_ROUTES = {
    DEFERRAL: { path: '/deferral/:id' },
};

export function configureDeferralLinkRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: DEFERRAL_LINK_ROUTES,
            config: {},
        },
    ];
}

function DeferralLinkPage() {
    const { id } = useParams();
    return <DeferralLinkComponent id={id} />;
}

export function getDeferralLinkRoutes() {
    return (
        <Route id="deferral-link-routes" element={<Outlet />}>
            <Route
                path={DEFERRAL_LINK_ROUTES.DEFERRAL.path}
                element={
                    <ProtectedRoute accessPolicy="hasLearnerAccess">
                        <DeferralLinkPage />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
